import { IPafClientForm } from "../../_api";

/** Tab 0 (Company) fields for ListOwner: full set. */
const COMPANY_TAB_0_LIST_OWNER: ReadonlyArray<keyof IPafClientForm> = [
  "company__company_name",
  "company__parent_company_name",
  "company__dba_name",
  "company__naics_code",
  "company__federal_tax_id",
  "company__usps_mailer_id",
  "company__carrier_route_id",
  "company__company_registration_id",
  "company__company_website",
  "company__customer_since_date",
  "is_foreign_location",
  "is_ncoa",
  "is_dsf",
  "is_triplex",
  "is_waiver_on_file",
];

/** Tab 0 (Company) fields for ListAdmin: visible only (no parent_company_name, dba_name, usps_mailer_id, company_registration_id). */
const COMPANY_TAB_0_LIST_ADMIN: ReadonlyArray<keyof IPafClientForm> = [
  "company__company_name",
  "company__naics_code",
  "company__federal_tax_id",
  "company__carrier_route_id",
  "company__company_website",
  "company__customer_since_date",
  "is_foreign_location",
  "is_ncoa",
  "is_dsf",
  "is_triplex",
  "is_waiver_on_file",
  "listadmin_type",
  "notes",
];

const COMPANY_TAB_1: ReadonlyArray<keyof IPafClientForm> = [
  "company__address1",
  "company__address2",
  "company__city",
  "company__state",
  "company__postal_code",
  "company__urbanization",
];

const COMPANY_TAB_2: ReadonlyArray<keyof IPafClientForm> = [
  "company__representative_name",
  "company__representative_title",
  "company__representative_email",
  "company__phone",
];

export const COMPANY_TAB_FIELDS: ReadonlyArray<
  ReadonlyArray<keyof IPafClientForm>
> = [COMPANY_TAB_0_LIST_OWNER, COMPANY_TAB_1, COMPANY_TAB_2];

/** Use for Next/Save: when isListAdmin, tab 0 validates only visible fields (no hidden ListOwner-only fields). */
export function getCompanyTabFields(
  isListAdmin: boolean
): ReadonlyArray<ReadonlyArray<keyof IPafClientForm>> {
  return [
    isListAdmin ? COMPANY_TAB_0_LIST_ADMIN : COMPANY_TAB_0_LIST_OWNER,
    COMPANY_TAB_1,
    COMPANY_TAB_2,
  ];
}
